"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRemoteFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22.58 18H9.46A3.44 3.44 0 006 21.43V30h20v-8.57A3.44 3.44 0 0022.58 18zM12.44 12.84l1.49 1.32a2.42 2.42 0 014.14 0l1.49-1.32a4.38 4.38 0 00-7.12 0z" }),
        React.createElement("path", { d: "M21.78 10.86l1.49-1.32a9.25 9.25 0 00-14.54 0l1.49 1.32a7.26 7.26 0 0111.56 0z" }),
        React.createElement("path", { d: "M16 3a12.17 12.17 0 019.49 4.57L27 6.24a14.14 14.14 0 00-22 0l1.51 1.32A12.17 12.17 0 0116 3z" })));
}
exports.default = SvgRemoteFilled;
//# sourceMappingURL=RemoteFilled.js.map